import React from 'react';
import { Box } from '@clariness/clarikit-react';

type AuthPageLayoutFormProps = React.PropsWithChildren<{
  onSubmit: () => void;
}>;

const formAttributes = { noValidate: true };

export const AuthPageLayoutForm: React.FC<AuthPageLayoutFormProps> = ({
  children,
  onSubmit,
}) => {
  return (
    <Box
      as="form"
      role="form"
      {...formAttributes}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="20px"
      width="100%"
      style={{ fontSize: '18px', textAlign: 'start' }}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      {children}
    </Box>
  );
};
